// googleMapsLoader.js
let googleMapsPromise = null;

const getGoogleMapsApiKey = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY?.trim();
  if (!apiKey) {
    throw new Error(
      'Missing REACT_APP_GOOGLE_MAPS_API_KEY. Add it to .env.local and restart the dev server.'
    );
  }
  return apiKey;
};

export const loadGoogleMaps = () => {
  // If already loaded, return resolved promise
  if (window.google && window.google.maps) {
    return Promise.resolve(window.google);
  }

  // If already loading, return the existing promise
  if (googleMapsPromise) {
    return googleMapsPromise;
  }

  // Create a new promise to load the script
  googleMapsPromise = new Promise((resolve, reject) => {
    let apiKey;
    try {
      apiKey = getGoogleMapsApiKey();
    } catch (error) {
      reject(error);
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
    script.async = true;
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error('Google Maps API failed to load'));
    document.body.appendChild(script);
  });

  return googleMapsPromise;
};

// Optional: Expose a function to check if Google Maps is loaded
export const isGoogleMapsLoaded = () => !!window.google?.maps;